// extracted by mini-css-extract-plugin
module.exports = {"container":"AnnualReportView_container__N-VWU","content":"AnnualReportView_content__38zA5","mainContent":"AnnualReportView_mainContent__1VlRR"};